import { snapshotBlockStyles } from 'app/shared/modules/EntityAuditHistory/EntityAuditHistory.styles';

export const paneHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
  minHeight: '28px',
};

// A Prism document runs to thousands of lines; it scrolls in place instead of stretching the drawer.
export const rawJsonBlockStyles = {
  ...snapshotBlockStyles,
  maxHeight: '480px',
  overflowY: 'auto',
};
